/** @format */

import axios from "axios";
import React, { useEffect, useState } from "react";

import { header } from "../../../../../components/api/Header";
import BarChart from "../../../../../components/Charts/BarChart";
import PieChart1 from "../../../../../components/Charts/PieChart1";
import BarChart2 from "../../../../../components/Charts/BarChart2";
import PieChart3 from "../../../../../components/Charts/PieChart3";
import BarChart3 from "../../../../../components/Charts/BarChart3";
import { getEnv } from "../../../../../lib/env";

function Page1({ date }) {
  const [data, setData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios
        .get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/sirdaryo/graph?date=" +
            date,
          header()
        )
        .catch((e) => {
          console.log("Xato", e);
          alert("Serverga ulanishda xato");
        });
      if (res) {
        setData(res.data);
      }
    };
    fetchData();
  }, [date]);

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-md-4 mb-3'>
          <div className='pie-box' style={{ height: "300px" }}>
            <div className='zarafshon-chart-table'>
              <h4>Norin daryosi</h4>
            </div>

            {data ? (
              <PieChart1
                d1={data["d"]["1"]}
                d2={data["d"]["2"]}
                d3={data["d"]["3"]}
                f1={data["f"]["1"]}
                f2={data["f"]["2"]}
                f3={data["f"]["3"]}
              />
            ) : null}
          </div>
        </div>

        <div className='col-md-4 mb-3'>
          <div className='pie-box' style={{ height: "300px" }}>
            <div className='zarafshon-chart-table'>
              <h4>Qoradaryo</h4>
            </div>

            {data ? (
              <PieChart3
                d1={data["d"]["4"]}
                d2={data["d"]["5"]}
                f1={data["f"]["4"]}
                f2={data["f"]["5"]}
              />
            ) : null}
          </div>
        </div>

        <div className='col-md-4 mb-3'>
          <div className='pie-box' style={{ height: "300px" }}>
            <div className='zarafshon-chart-table'>
              <h4>Sirdaryo</h4>
            </div>

            {data ? (
              <PieChart1
                d1={data["d"]["6"]}
                d2={data["d"]["7"]}
                d3={data["d"]["8"]}
                f1={data["f"]["6"]}
                f2={data["f"]["7"]}
                f3={data["f"]["8"]}
              />
            ) : null}
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-md-4'>
          <div
            className='pie-box _pie-box barchart-box'
            style={{ height: "300px" }}>
            <div className='zarafshon-chart-table mb-2'>
              <h4>
                Norin daryosi (m<sup>3</sup>/s)
              </h4>
            </div>

            {data ? (
              <BarChart2
                d1={data["d"]["14"]}
                d2={data["d"]["15"]}
                d3={data["d"]["16"]}
              />
            ) : null}
          </div>
        </div>

        <div className='col-md-4'>
          <div
            className='pie-box _pie-box barchart-box'
            style={{ height: "300px" }}>
            <div className='zarafshon-chart-table mb-2'>
              <h4>
                Qoradaryo (m<sup>3</sup>/s)
              </h4>
            </div>
            {data ? (
              <BarChart3 d1={data["d"]["17"]} d2={data["d"]["18"]} />
            ) : null}
          </div>
        </div>

        <div className='col-md-4'>
          <div
            className='pie-box _pie-box barchart-box'
            style={{ height: "300px" }}>
            <div className='zarafshon-chart-table mb-2'>
              <h4>
                Sirdaryo (m<sup>3</sup>/s)
              </h4>
            </div>

            {data ? (
              <BarChart
                d1={data["d"]["9"]}
                d2={data["d"]["10"]}
                d3={data["d"]["11"]}
                d4={data["d"]["12"]}
                d5={data["d"]["13"]}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page1;
